import React from "react";
import { StyledImage } from "./styles";
import { ImageProps } from "./types";

/**
 * Componente Image
 *
 * Um wrapper estilizado para imagens, com suporte a personalização de dimensões, bordas e comportamento de ajuste.
 *
 * @param {string | StaticImageData} src - URL da imagem ou objeto StaticImageData.
 * @param {string} alt - Texto alternativo para acessibilidade.
 * @param {string} [width='auto'] - Largura customizada da imagem.
 * @param {string} [height='auto'] - Altura customizada da imagem.
 * @param {string} [borderRadius='none'] - Define bordas arredondadas.
 * @param {'cover' | 'contain' | 'fill' | 'none' | 'scale-down'} [objectFit='cover'] - Define como o conteúdo da imagem será ajustado.
 * @param {'lazy' | 'eager'} [loading='lazy'] - Estratégia de carregamento da imagem.
 */
export const Image: React.FC<ImageProps> = ({
  src,
  alt,
  width = "auto",
  height = "auto",
  borderRadius = "none",
  objectFit = "cover",
  loading = "lazy",
}) => (
  <StyledImage
    src={src}
    alt={alt}
    loading={loading}
    $width={width}
    $height={height}
    $borderRadius={borderRadius}
    $objectFit={objectFit}
  />
);
